import React, { Component } from 'react'
import PropTypes from 'prop-types'
import filesize from 'filesize'
import styles from './FileUploader.scss'
import { IconDropzone, IconDelete, IconPage } from 'icons'
import FineUploaderTraditional from 'fine-uploader-wrappers'
import FileInput from 'react-fine-uploader/file-input'
import Filename from 'react-fine-uploader/filename'
import CancelButton from 'react-fine-uploader/cancel-button'

class FileUploader extends Component {
  static propTypes = {
    allowedExtensions: PropTypes.arrayOf(PropTypes.string),
    uploadTitle: PropTypes.string,
    uploadDescText: PropTypes.string,
    multiple: PropTypes.bool,
    // updateFunction: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
    children: PropTypes.object,
    uploader: PropTypes.object.isRequired,
    setFileUploaderResponse: PropTypes.func,
    setSubmittedFiles: PropTypes.func,
    
  }

  static defaultProps = {
    allowedExtensions: ['*'],
    uploadTitle: 'Upload',
    uploadDescText: '',
    disabled: false,
    children: null,
    setFileUploaderResponse: null,
  }

  static fileSizeDesc = (size) => {
    return Number.isNaN(size) ? size : filesize(size)
  }

  constructor() {
    super()
    this.state = {
      submittedFiles: [],
    }
  }

  componentDidMount() {
    this.props.uploader.on('statusChange', (id, oldStatus, newStatus) => {
      const submittedFiles = this.state.submittedFiles
      if (newStatus === 'submitted') {
        submittedFiles.push(id)
        this.setState({ submittedFiles })
        this.props.setSubmittedFiles(submittedFiles)
      } else if (this.isFileGone(newStatus)) {
        const indexToRemove = submittedFiles.indexOf(id)

        submittedFiles.splice(indexToRemove, 1)
        this.setState({ submittedFiles })
        this.props.uploader.methods.removeFileRef(id)
        this.props.setSubmittedFiles(submittedFiles)
      }
    })

    this.props.uploader.on('onComplete', (id, name, responseJSON) => {
      this.props.setFileUploaderResponse(responseJSON)
    })

    this.props.uploader.on('onAllComplete', (succeeded, failed) => {
      const RESPONSE_JSON = {}
      const successfulUploadResponses = succeeded.map(id => RESPONSE_JSON[id])
      this.props.setFileUploaderResponse(successfulUploadResponses)
    })
  }

  isFileGone = (status) => {
    return [
      'canceled',
      'deleted',
    ].indexOf(status) >= 0
  }

  render() {
    const {
      uploader, uploadTitle, uploadDescText,
      allowedExtensions, disabled, multiple,
    } = this.props
    const { submittedFiles } = this.state
    const extensions = allowedExtensions.map(e => `.${e}`).reduce((a, b) => `${a},${b}`)

    return (
      <div className={disabled ? styles.disabled : null}>
        <FileInput
          accept={extensions}
          className={styles.dropzone}
          disabled={disabled}
          multiple={multiple}
          uploader={uploader}
        >
          <IconDropzone />
          <div>
            <p className={styles.title}>{uploadTitle}</p>
            <p>{uploadDescText}</p>
          </div>
        </FileInput>

        <div className={styles.underDropzone}>
          {this.props.children}

          <ul>
            {this.state.submittedFiles.map(id =>
              (<li className={styles.toUpload} key={id}>
                <IconPage className={styles.fileIcon} />
                <p className={styles.fileName}>
                  <Filename
                    id={id}
                    uploader={uploader}
                  />
                </p>
                <div className={styles.loadingIndicator}>
                  <CancelButton id={id} uploader={uploader}>
                    <IconDelete height="20" width="20" />
                  </CancelButton>
                </div>
              </li>))}
          </ul>
        </div>
      </div>
    )
  }
}

export default FileUploader



// WEBPACK FOOTER //
// ./src/components/FileUploader/FileUploader.js